/**
 * GET /v1/athletics-hub — sport-grouped grid of current-season ATHLETICS
 * sections for any authenticated school member.
 *
 * Response groups grid items by `sportName`, with a reserved "Other" bucket
 * (`ATHLETICS_HUB_OTHER_SPORT_KEY`) for null-sport sections (KTD7). The level
 * filter is NOT applied server-side — it is a conditional client-side
 * affordance — so this endpoint returns all current-season ATHLETICS sections.
 *
 * See: docs/_archive/2026-10-17-plans-sweep/plans/2026-06-18-004-feat-athletics-hub-front-door-plan.md (U1)
 */

import { z } from 'zod'
import { AthleticsHubSportGroupSchema } from './common'

/**
 * List response — the sport-grouped grid. `.strict()` so a response carrying
 * unexpected wire fields fails the contract (wire-exclusion is enforced).
 */
export const AthleticsHubListResponseSchema = z
  .object({
    /** Sport groups in display order; includes the reserved "Other" bucket when present. */
    sport_groups: z.array(AthleticsHubSportGroupSchema)
  })
  .strict()
export type AthleticsHubListResponse = z.infer<typeof AthleticsHubListResponseSchema>
